// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ni-0";
export var animationContainer = "_ni-1";
export var itemPrice = "_ni-a";
export var itemizedContent = "_ni-9";
export var itemizedHeader = "_ni-7";
export var itemizedRow = "_ni-8";
export var itemizedSection = "_ni-6";
export var modalContent = "_ni-2";
export var orderName = "_ni-3";
export var refundOption = "_ni-4";
export var refundOptionsContainer = "_ni-5";
export var shippingLabel = "_ni-b";
export var totalRow = "_ni-c";